import axios from 'axios'

export const validateCoupon = async (
  couponCode: string,
  totalValue: number,
) => {
  const url = `${import.meta.env.VITE_BASEAPIURL}/admin/orders/apply_discount_coupon`

  const response = await axios.get(url, {
    params: {
      coupon_code: couponCode,
      total_value: totalValue,
      company_id: import.meta.env.VITE_COMPANY_ID,
    },
  })
  return response.data
}
